class ProductMedia extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      slider: "[data-slider]",
      mediaItem: "[data-media-id]",
      modalOpeners: "[data-modal-opener-id]",
      zoomImages: "[data-pswp-image]",
      btnXr: "[data-shopify-xr]",
    };
    this.selectedMediaIndex =
      Number(
        this.querySelector(this.selectors.slider).querySelector(
          "[data-selected]"
        )?.dataset.index
      ) || 0;

    const swiperElement = document.getElementById("product__media-slider");
    let swiperOptions = {};
    try {
      const optionsString = this.querySelector(
        this.selectors.slider
      ).getAttribute("data-swiper-options");
      swiperOptions = optionsString ? JSON.parse(optionsString) : {};
    } catch (error) {
      console.error("Invalid JSON in data-swiper-options:", error);
    }

    const withThumbs = this.dataset.withThumbs === "true";

    this.settings = {
      sliderElement: this.querySelector(this.selectors.slider),
      sliderInstance: null,
      options: {
        ...swiperOptions,
        initialSlide: this.selectedMediaIndex,
        navigation: {
          prevEl: this.querySelector(".swiper-button-prev"),
          nextEl: this.querySelector(".swiper-button-next"),
        },
        pagination: {
          el: ".swiper-pagination",
          type: "progressbar",
        },
        spaceBetween: 2,
        watchOverflow: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        preventInteractionOnTransition: false,
        autoHeight: this.dataset.autoHeight === "true",
        loop: true,
        allowTouchMove: true,
        speed: 500,
        on: {
          afterInit: (swiper) => this.afterInit(swiper),
          slideChangeTransitionEnd: (swiper) =>
            this.setActiveModalOpener(swiper),
          transitionStart: (swiper) => this.pauseAllVideos(swiper),
          transitionEnd: (swiper) => this.playActiveSlideVideo(swiper),
        },
      },
    };

    if (withThumbs) {
      this.initThumbnails(swiperElement);
    } else {
      this.settings.options.slidesPerView = 1;
    }
  }

  afterInit(swiper) {
    if (swiper.slides.length > 1) {
      this.playActiveSlideVideo(swiper);
    }
  }

  pauseAllVideos(swiper) {
    swiper.el.querySelectorAll("video").forEach((video) => video.pause());
  }

  playActiveSlideVideo(swiper) {
    const activeSlide = swiper.slides[swiper.activeIndex];
    if (!activeSlide) return;
    const video = activeSlide.querySelector("video");
    if (video) this.playPromise(video);
  }

  playPromise(video) {
    let playPromise = video.play();
    if (playPromise !== undefined) {
      playPromise.catch(() => video.pause());
    }
  }

  initThumbnails(swiperElement) {
    const thumbSwiper = new Swiper(".swiper-thumbs", {
      initialSlide: this.selectedMediaIndex,
      centeredSlides: false,
      centeredSlidesBounds: true,
      freeMode: false,
      direction: "horizontal",
      slidesPerView: 3.5,
      spaceBetween: 8,
      threshold: 5,
      watchOverflow: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      breakpoints: {
        750: {
          direction: swiperElement.dataset.thumbsDirectionDesktop || "vertical",
          spaceBetween: 8,
          slidesPerView: 3.5,
        },
      },
    });

    this.settings.options.thumbs = { swiper: thumbSwiper };

    this.settings.options.on.slideChange = (swiper) => {
      const currentIndex = swiper.realIndex;
      if (currentIndex >= 3) {
        thumbSwiper.slideTo(currentIndex - 2);
      } else {
        thumbSwiper.slideTo(0);
      }
    };
  }

  connectedCallback() {
    this.init();
    this.attachArrowEvents();
  }

  init() {
    if (!this.settings.sliderElement) return;
    this.settings.sliderInstance = new Swiper(
      this.settings.sliderElement,
      this.settings.options
    );
  }

  attachArrowEvents() {
    const prevBtn = this.querySelector(".swiper-button-prev");
    const nextBtn = this.querySelector(".swiper-button-next");
    if (prevBtn && nextBtn && this.settings.sliderInstance) {
      prevBtn.addEventListener("click", () => {
        this.settings.sliderInstance.slidePrev();
      });
      nextBtn.addEventListener("click", () => {
        this.settings.sliderInstance.slideNext();
      });
    }
  }

  setActiveModalOpener(swiper) {
    const activeSlide = swiper.slides[swiper.activeIndex];
    if (!activeSlide) return;
    const activeMediaId = activeSlide.dataset.mediaId;
    this.querySelector(
      `${this.selectors.modalOpeners}.is-active`
    )?.classList.remove("is-active");
    this.querySelector(
      `${this.selectors.modalOpeners} [data-media-id="${activeMediaId}"]`
    )?.parentElement.classList.add("is-active");
    if (activeSlide.dataset.mediaType === "model") {
      this.querySelector(this.selectors.btnXr).dataset.shopifyModel3dId =
        activeMediaId;
    }
  }
}

customElements.define("product-media", ProductMedia);
